var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { makeObservable, observable, action } from "mobx";
export class WebViewReportsState {
    constructor() {
        this.topposition = 30;
        this.leftposition = 200;
        this.width = window.innerWidth < 600 ? window.innerWidth - 50 : 550;
        this.height = window.innerHeight < 550 ? window.innerHeight - 50 : 500;
        this.dragging = false;
        this.show = false;
        this.selectedReports = new Map();
        makeObservable(this);
    }
    setShow(show) {
        this.show = show;
    }
    setDragging(drag) {
        this.dragging = drag;
    }
    setToppos(pos) {
        this.topposition = pos;
    }
    setLeftPos(pos) {
        console.log(pos);
        this.leftposition = pos;
    }
    addReport(id, smd) {
        this.selectedReports.set(id, smd);
    }
    removeReport(id) {
        this.selectedReports.delete(id);
    }
    reset() {
        this.selectedReports.clear();
    }
    setUseAllForReport(use, id) {
        const smd = this.selectedReports.get(id);
        if (smd !== undefined) {
            smd.useall = use;
            if (use) {
                smd.schemaitemids = [];
            }
        }
    }
    setSchemaItemsForReport(use, rid, id) {
        const smd = this.selectedReports.get(rid);
        if (smd !== undefined) {
            if (smd.schemaitemids === undefined) {
                smd.schemaitemids = [];
            }
            if (use) {
                smd.schemaitemids.push(id);
            }
            else {
                let index = smd.schemaitemids.indexOf(id);
                if (index > -1) {
                    smd.schemaitemids.splice(index, 1);
                }
            }
        }
    }
}
__decorate([
    observable,
    __metadata("design:type", Object)
], WebViewReportsState.prototype, "topposition", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], WebViewReportsState.prototype, "leftposition", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], WebViewReportsState.prototype, "width", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], WebViewReportsState.prototype, "height", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], WebViewReportsState.prototype, "dragging", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], WebViewReportsState.prototype, "show", void 0);
__decorate([
    observable,
    __metadata("design:type", Map)
], WebViewReportsState.prototype, "selectedReports", void 0);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], WebViewReportsState.prototype, "setShow", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], WebViewReportsState.prototype, "setDragging", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], WebViewReportsState.prototype, "setToppos", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], WebViewReportsState.prototype, "setLeftPos", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String, Object]),
    __metadata("design:returntype", void 0)
], WebViewReportsState.prototype, "addReport", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], WebViewReportsState.prototype, "removeReport", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], WebViewReportsState.prototype, "reset", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean, String]),
    __metadata("design:returntype", void 0)
], WebViewReportsState.prototype, "setUseAllForReport", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean, String, String]),
    __metadata("design:returntype", void 0)
], WebViewReportsState.prototype, "setSchemaItemsForReport", null);
